/* Pluszkowo 1.8 – bajka.js
   Postacie reagują na dotyk (podskok + dymek z odgłosem), powitalny podskok ekipy,
   gwiazdki w sekcjach, pasek „Wybierz swoją postać” na telefonie, przycisk „Wyślij link”. */
(function () {
  'use strict';
  var html = document.documentElement;
  var off = html.getAttribute('data-fairy') === 'off';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Postacie: podskok + dymek ---------- */
  var SOUNDS = { weg: 'Rrrau! Jestem smokiem!', pre: 'Mrrr… miau!', pyz: 'Chrum, chrum!', rec: 'Kum, kum!', dyn: 'Bu! Psikus!' };
  var HOSTS = '.spot__tab, .sizer__chip, .switcher__list li, .gallery__face, .quiz__faces li, .nav__char, .mnav-squad a, .avatar--face, [data-bajka-boop]';
  var last = typeof WeakMap === 'function' ? new WeakMap() : null;

  function faceKey(el) {
    var svg = el.matches && el.matches('svg.face') ? el : el.querySelector && el.querySelector('svg.face');
    if (!svg) return null;
    var m = (svg.getAttribute('class') || '').match(/face--([a-z]+)/);
    return m ? m[1] : null;
  }
  function bubble(target, text) {
    var r = target.getBoundingClientRect();
    if (!r.width) return;
    var b = document.createElement('span');
    b.className = 'bajka-bubble';
    b.setAttribute('aria-hidden', 'true');
    b.textContent = text;
    b.style.left = Math.min(Math.max(r.left + r.width / 2, 84), window.innerWidth - 84) + 'px';
    b.style.top = Math.max(r.top - 4, 48) + 'px';
    document.body.appendChild(b);
    setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 1650);
  }
  function boop(host) {
    var now = Date.now();
    if (last && now - (last.get(host) || 0) < 650) return;
    if (last) last.set(host, now);
    var target = host.querySelector('.spot__tab-face, .avatar, svg.face') || host;
    target.classList.remove('is-boop');
    void target.offsetWidth;
    target.classList.add('is-boop');
    target.addEventListener('animationend', function () { target.classList.remove('is-boop'); }, { once: true });
    var k = faceKey(host);
    if (k && SOUNDS[k]) bubble(target, SOUNDS[k]);
  }
  if (!off && !reduce) {
    document.addEventListener('click', function (e) {
      var host = e.target.closest && e.target.closest(HOSTS);
      if (host) boop(host);
    }, { passive: true });
  }

  /* ---------- 2. Powitalny podskok ekipy ---------- */
  if (!off && !reduce && 'IntersectionObserver' in window) {
    var groups = Array.prototype.slice.call(document.querySelectorAll('.spot__tabs, .quiz__faces, .switcher__list'));
    var chip = document.querySelector('.sizer__chip');
    if (chip && chip.parentElement) groups.push(chip.parentElement);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        en.target.querySelectorAll('svg.face').forEach(function (f, i) {
          setTimeout(function () {
            f.classList.add('bajka-hop');
            f.addEventListener('animationend', function () { f.classList.remove('bajka-hop'); }, { once: true });
          }, 250 + i * 120);
        });
      });
    }, { threshold: 0.6 });
    groups.forEach(function (g) { io.observe(g); });
  }

  /* ---------- 3. Gwiazdki i chmurki w sekcjach ---------- */
  if (!off) {
    var SPOTS = [[7, 14, 12, 0], [90, 20, 10, 1.2], [76, 86, 8, 2.1], [14, 78, 9, .7]];
    var COLS = ['#FFD86B', '#C9B8FF', '#FF8FB1', '#8FD3FF'];
    document.querySelectorAll('#MainContent .section:not(.spooky):not(.fpromise):not(.crew)').forEach(function (sec, si) {
      if (sec.querySelector(':scope > .bajka-sky')) return;
      var sky = document.createElement('div');
      sky.className = 'bajka-sky';
      sky.setAttribute('aria-hidden', 'true');
      var h = '';
      SPOTS.forEach(function (s, i) {
        h += '<span class="fstar" style="--x:' + s[0] + '%;--y:' + s[1] + '%;--s:' + s[2] + 'px;--d:' + (s[3] + si * 0.3).toFixed(1) + 's;--c:' + COLS[(i + si) % 4] + '"></span>';
      });
      if (si % 2 === 0) h += '<span class="fcloud bajka-sky__cloud"></span>';
      sky.innerHTML = h;
      sec.classList.add('has-sky');
      sec.insertBefore(sky, sec.firstChild);
    });
  }

  /* ---------- 4. Pasek „Wybierz swoją postać” (telefon, strona główna) ---------- */
  var dock = document.querySelector('[data-bajka-dock]');
  if (dock && 'IntersectionObserver' in window) {
    var st = { hero: true, squad: false, foot: false };
    var link = dock.querySelector('a');
    var sync = function () {
      var cb = document.querySelector('[data-cookie-banner]');
      var cookieOpen = cb && !cb.hidden;
      var on = !st.hero && !st.squad && !st.foot && !cookieOpen;
      dock.classList.toggle('is-on', on);
      html.classList.toggle('has-dock', on);
      dock.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (link) link.tabIndex = on ? 0 : -1;
    };
    var watch = function (sel, key) {
      var el = document.querySelector(sel);
      if (!el) { st[key] = false; return; }
      new IntersectionObserver(function (en) { st[key] = en[0].isIntersecting; sync(); }, { rootMargin: '0px 0px -15% 0px' }).observe(el);
    };
    watch('.hero', 'hero');
    watch('#ekipa', 'squad');
    watch('.footer', 'foot');
    var cookieEl = document.querySelector('[data-cookie-banner]');
    if (cookieEl && 'MutationObserver' in window) new MutationObserver(sync).observe(cookieEl, { attributes: true, attributeFilter: ['hidden'] });
    sync();
  }

  /* ---------- 5. „Wyślij link do tej piżamki” ---------- */
  function toast(msg) {
    var t = document.querySelector('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    t.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.classList.remove('is-visible'); t.hidden = true; }, 2600);
  }
  var buy = document.querySelector('.pdp__buy');
  if (buy && !document.querySelector('.bajka-share')) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bajka-share';
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7"/><path d="M12 3v12"/><path d="m7 8 5-5 5 5"/></svg><span>Wyślij link do tej piżamki</span>';
    buy.parentNode.insertBefore(btn, buy.nextSibling);
    btn.addEventListener('click', function () {
      var titleEl = document.querySelector('.pdp__title');
      var data = { title: titleEl ? titleEl.textContent.trim() : document.title, url: location.href };
      if (navigator.share) { navigator.share(data).catch(function () {}); return; }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(data.url).then(function () { toast('Link skopiowany. Wklej go, komu chcesz.'); }, function () { toast(data.url); });
      } else { toast(data.url); }
    });
  }
})();
